import { useEffect, useState } from 'react';

type ProductImageGalleryProps = {
  images?: string[] | null;
}

const ProductImageGallery = ({ images }: ProductImageGalleryProps) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  useEffect(() => {
    if (images && images.length > 0) {
      setSelectedImage(images[0]);
    }
  }, [images]);

  const hasImages = images && images.length > 0;
  
  if (!hasImages) {
    return (
      <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 items-start">
        <div className="w-full sm:flex-1 min-w-0 h-[360px] sm:h-[520px] bg-white border rounded-md shadow-sm flex items-center justify-center p-6">
          <p className="text-gray-500 italic text-center">{"Sem imagens disponíveis para esse produto."}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 items-start">
      <div className="flex flex-row sm:flex-col gap-2 sm:gap-3 px-1 sm:px-0 py-1 sm:py-0 overflow-x-auto sm:overflow-visible order-2 sm:order-1 w-full sm:w-20">
        {images?.map((img, idx) => (
          <button
            key={idx}
            onClick={() => setSelectedImage(img)}
            className={`border rounded-md overflow-hidden w-16 sm:w-20 h-16 sm:h-20 p-0.5 flex-shrink-0 bg-white
              ${selectedImage === img ? 'ring-2 ring-primary-600' : 'hover:border-primary-600'}`}
          >
            <img
              src={img}
              alt={`Miniatura ${idx + 1}`}
              className="w-full h-full object-cover"
            />
          </button>
        ))}
      </div>

      <div className="w-full sm:flex-1 min-w-0 h-[360px] sm:h-[520px] bg-white border rounded-md shadow-sm order-1 sm:order-2 flex items-center justify-center overflow-hidden">
        {selectedImage && (
          <img
            src={selectedImage}
            alt={"Produto selecionado"}
            className="max-h-full max-w-full object-contain p-2 sm:p-4"
          />
        )}
      </div>
    </div>
  );
};

export default ProductImageGallery;
